import { render, staticRenderFns } from "./PrivateInvitationController.vue?vue&type=template&id=0b3b0e55&scoped=true&"
import script from "./PrivateInvitationController.vue?vue&type=script&lang=ts&"
export * from "./PrivateInvitationController.vue?vue&type=script&lang=ts&"
import style0 from "./PrivateInvitationController.vue?vue&type=style&index=0&id=0b3b0e55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3b0e55",
  null
  
)

export default component.exports